import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Footer } from '@/components/Footer';

export default function Join() {
  const { roomId: paramRoomId } = useParams();
  const [roomId, setRoomId] = useState(paramRoomId || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (paramRoomId) {
      setRoomId(paramRoomId);
    }
  }, [paramRoomId]);

  const handleJoin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!roomId.trim()) return;

    setLoading(true);
    setError(null);

    try {
      // Check if room exists
      const response = await fetch(`/api/rooms/${roomId}`);

      if (response.ok) {
        // Go directly to room - user name comes from registered user
        navigate(`/room/${roomId}`);
      } else {
        const data = await response.json();
        setError(data.error || 'Room not found');
      }
    } catch (err) {
      setError('Failed to connect to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-primary mb-2">
            Join <span className="text-lime-400">Room</span>
          </h1>
          <p className="text-secondary">
            Enter the room code to join
          </p>
        </div>

        <div className="card">
          <form onSubmit={handleJoin} className="space-y-6">
            <div>
              <label htmlFor="roomId" className="block text-sm font-bold text-primary mb-2">
                Room Code
              </label>
              <input
                type="text"
                id="roomId"
                value={roomId}
                onChange={(e) => setRoomId(e.target.value.toUpperCase())}
                placeholder="ABC123"
                className="input text-center text-2xl tracking-widest font-mono uppercase"
                required
                autoFocus
                maxLength={10}
              />
            </div>

            {error && (
              <div className="text-red-400 text-sm bg-red-500/10 border border-red-500/30 p-3 rounded-lg">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !roomId.trim()}
              className="btn-primary w-full"
            >
              {loading ? 'Joining...' : 'Join Room'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-lime-400 hover:text-lime-300 text-sm font-bold transition"
            >
              Back to Home
            </button>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
